/* istanbul ignore file */
import UploadService from './uploadApi';

export default UploadService;
